import { useState, useEffect } from "react";
let timer;

const Clock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    timer = setInterval(() => setTime(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });

  return <span>Czas: {time.toLocaleTimeString()}</span>;
};

export default Clock;
